import React from 'react';
import { EmptyLogs } from '#component/warehouse/warehouse-log/empty-log';
import EventDescription from '#component/warehouse/warehouse-log/event-description';
import LogsTableView from '#component/general/logs-table-view/logs-table-view';

const TableView = props => {
  const { account, loading, error, logs, handleRequestSort, order } = props;

  return (
    <LogsTableView
      account={account}
      logs={logs}
      loading={loading}
      error={error}
      order={order}
      handleRequestSort={handleRequestSort}
      renderActionCell={log => (
        <EventDescription log={log} account={account} />
      )}
      EmptyStateComponent={EmptyLogs}
    />
  );
};

export default TableView;
